enum PropiedadItem {
    Bool= 'Bool',
    Numero= 'Numero',
    Texto= 'Texto',
}
export default PropiedadItem;
